import { Select } from "antd";
import * as React from "react";
import { useEffect } from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectLedgerCategory {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectLedgerCategory = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectLedgerCategory) => {
  const itemList = useStoreState((state) => state.ledger.categoryList);

  const itemListFetch = useStoreActions((state) => state.ledger.fetchcategoryList);

  useEffect(()=>{
    itemListFetch();
  },[])

  const onSelect = (id) => {
    if (itemList) {
      const val = itemList.find((item) => item.categoryId === id);
      onChange(val?.categoryId);
    }
  };




  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      allowClear
      placeholder="Select Category"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.categoryId} value={type.categoryId}>
            {type.categoryName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Category</Option>
      )}
    </Select>
  );
};
